import { createI18n } from 'vue-i18n'
import de from './locales/de.json'
import en from './locales/en.json'

const STORAGE_KEY = 'gessner-lang'
const SUPPORTED = ['de', 'en']
const FALLBACK = 'de'

function detectLocale() {
    if (typeof localStorage !== 'undefined') {
        const saved = localStorage.getItem(STORAGE_KEY)
        if (saved && SUPPORTED.includes(saved)) return saved
    }
    if (typeof navigator !== 'undefined' && navigator.language) {
        const code = navigator.language.toLowerCase().split('-')[0]
        if (SUPPORTED.includes(code)) return code
    }
    return FALLBACK
}

const initial = detectLocale()

export const i18n = createI18n({
    legacy: false,
    locale: initial,
    fallbackLocale: FALLBACK,
    messages: { de, en },
})

if (typeof document !== 'undefined') {
    document.documentElement.lang = initial
}

export function setLocale(locale) {
    if (!SUPPORTED.includes(locale)) return
    i18n.global.locale.value = locale
    try {
        localStorage.setItem(STORAGE_KEY, locale)
    } catch {
        // ignore
    }
    if (typeof document !== 'undefined') {
        document.documentElement.lang = locale
    }
}

export const supportedLocales = SUPPORTED
